export enum TransportType {
    Flight = "flight",
    Train = "train",
    Transfer = "transfer"
}